const Styles = {
  option: {
    "&.MuiAutocomplete-option[aria-disabled='true']": {
      pointerEvents: "inherit",

      "&:active": {
        pointerEvents: "none",
      },
    },
  },
};

export default Styles;
